import React, { Fragment } from 'react';
import Navbar from '../../components/Navbar/Navbar';
import PageTitle from '../../components/pagetitle/PageTitle';
import CtaSection from '../../components/CtaSection/CtaSection';
import Footer from '../../components/footer/Footer';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Logo from '../../images/Logo.png';
import Electricallighting from '../../components/electrical/elctricallighting';
import WhatsAppCTA from '../../components/whatsapp/whatappcta';
import ProjectSection3 from '../../components/ProjectSection3/ProjectSection3';


const ElectricallightingPage = () => {
    return (
        <Fragment>
            <Navbar Logo={Logo} />
            <PageTitle pageTitle={'Electrical & Lighting Solutions'} />
            <Electricallighting />

            <CtaSection />
            <ProjectSection3 />
            <WhatsAppCTA />
            <Footer />
            <Scrollbar />

        </Fragment>
    )
};

export default ElectricallightingPage ;